<template>
  <div v-if="featureState.visible" class="rights-feature" :class="[currentCls]">
    <div class="rights-feature__head">
      <span class="font-bold text-font-1">{{ feature.name }}</span>
    </div>
    <div class="relative">
      <div class="rights-feature__desc">{{ feature.desc.join('') }}</div>
      <a-button
        v-if="
          canAddSubAccount && featureType === RIGHTS_FEATURE.sub_account_num
        "
        size="small"
        type="primary"
        class="btn-add-seats"
        @click="useAddSeats"
      >
        {{ $t('jia-gou-xi-wei') }}
      </a-button>
      <div v-if="usage" class="text-[14px] text-right remaining">
        <span class="text-font-1">
          {{ $t('sheng-yu') }}：{{ props.usage?.remain }}
        </span>
        <span class="text-font-50">/{{ props.usage?.total }}</span>
      </div>
      <div
        v-if="rendering_channel_num !== undefined"
        class="highlight rights-feature__num"
      >
        {{ $t('dang-qian-renderingchannelnum-lu', [rendering_channel_num]) }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts" name="RightsFeature">
/** 子账号、服务器专线、存储空间 layout */
// import ExtraBtn from '../components/extra-btn.vue';
import { RIGHTS_FEATURE } from '~/api/interface/rights'
import { RightsFeature } from '~/constants'
import { useAddSeats } from '~/features/paymentDesk'
import { usePermission } from '~/hooks/usePermission.ts'

const { canAddSubAccount } = usePermission()

const props = withDefaults(
  defineProps<{
    featureType: RIGHTS_FEATURE
    featureState: {
      visible: boolean
      addable: boolean
    }
    usage?: {
      remain: number | string
      total: number | string
      percent: number
    }
    rendering_channel_num?: number
    disabled?: boolean
  }>(),
  {
    disabled: false,
  }
)

const feature = computed(() => RightsFeature()[props.featureType])
const currentCls = computed(() => `rights-feature--${props.featureType}`)
</script>

<style lang="scss" scoped>
.btn-add-seats {
  position: absolute;
  bottom: 0;
}
.rights-feature__desc {
  margin-bottom: 10px;
}
.remaining {
  line-height: 22px;
}
</style>
